import { useState } from 'react';
import useQueryParams from "~/utils/use-query-params";

export type InitialSignInMode = 'resetPassword' | 'confirmEmail' | undefined;

// shows a button that opens a dialog for signing in or signing up unless sessionUser 
export default function useShowSignUpFlow({
  autoOpenDialogOnToken = false
}: {
  // whether this component opens a dialogue automatically when tokens routes
  // are found. The issue being that there may be multiple of this component on 
  // the page and we only want one to open the dialog automatically. 
  autoOpenDialogOnToken?: boolean
} = {}) {
  const [reset_password_token] = useQueryParams({ keys: ['reset_password_token'] })
  const [confirmation_token] = useQueryParams({ keys: ['confirmation_token'] })
  const initialSignInMode: InitialSignInMode = reset_password_token ? 'resetPassword' : confirmation_token ? 'confirmEmail' : undefined;

  const [showSignInDialog, setShowSignInDialog] = useState(!!initialSignInMode && autoOpenDialogOnToken);

  return {
    showSignInDialog,
    setShowSignInDialog,
    initialSignInMode,
  }
}
